import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getProgramRequest,
  setSelectedBooks,
  setSelectedDirectors,
  setSelectedUsers
} from "../../../store/Programs/actions";
import AssignBooks from "./AssignBooks";
import AssignDirector from "./AssignDirector";
import AssignUsers from "./AssignUsers";
import EditUsers from "./EditUsers";
import EditProgram from "./EditProgram";
import styles from "./ProgramsEdit.module.scss";
export default function ProgramsEdit() {
  const { id } = useParams();
  const { selectedProgram } = useSelector((state) => state.programs);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getProgramRequest(id));
  }, []);

  useEffect(() => {
    dispatch(
      setSelectedBooks(selectedProgram?.books?.map((b) => b.id) ?? [])
    );
    dispatch(
      setSelectedUsers(selectedProgram?.users?.map((u) => u.id) ?? [])
    );
    dispatch(
      setSelectedDirectors(selectedProgram?.program_director?.id ?? 0)
    );
  }, [selectedProgram]);

  return (
    <div>
      <div className={styles.headerDiv}>
        <h3 className={styles.headerTitle}>
          {selectedProgram?.name}
        </h3>
        <dl className={styles.dateList}>
          <div>
            <dt>Start Date</dt>
            <dd>{selectedProgram?.start_date}</dd>
          </div>
          <div>
            <dt>End Date</dt>
            <dd>{selectedProgram?.end_date}</dd>
          </div>
        </dl>
        <p>
          <span>Total Students Limit</span> :{" "}
          {selectedProgram?.total_users_limit}
        </p>
        <p>
          <span>Number of Enrolled Students</span> :{" "}
          {selectedProgram?.used_users_limit}
        </p>
      </div>
      <div>
        <EditProgram id={id} selectedProgram={selectedProgram} />
        <AssignDirector id={id} selectedProgram={selectedProgram} />
        <AssignUsers id={id} />
        <EditUsers id={id} />
        <AssignBooks id={id} />
      </div>
    </div>
  );
}
